export interface IMap<T> {
    [key: string]: T;
}

export interface ITranslation {
    [lang: string]: string;
}

export const isTranslation = (obj: ITranslation | string): obj is ITranslation => {
    return typeof obj === 'object' && 'DE' in obj && 'EN' in obj && 'FR' in obj;
};
